import { handleAnswer } from 'utils/familyUtils'

/*
  🔵 Adiciona aos dados os atributos: isAlert, inconsistent. Onde os 
  alertas são calculados no front e as inconsistencias vem do back
*/

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function cardsInfosPregnancy(family: any, inconsistencies: any) {
  const cardsInfos = [
    {
      question: family.pregnantInHome.question,
      fieldName: family.pregnantInHome.fieldName,
      answer: handleAnswer(
        family.pregnantInHome.answer,
        family.pregnantInHome.type
      ),
      isAlert: false,
      inconsistent: inconsistencies?.nutrition?.includes('pregnantInHome'),
    },
  ]

  return cardsInfos
}

export default cardsInfosPregnancy
